import { render, staticRenderFns } from "./preview-section.vue?vue&type=template&id=3935f8fa&scoped=true"
import script from "./preview-section.vue?vue&type=script&lang=js"
export * from "./preview-section.vue?vue&type=script&lang=js"
import style0 from "./preview-section.vue?vue&type=style&index=0&id=3935f8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935f8fa",
  null
  
)

export default component.exports